<div class="container-fluid">
    <div class="row">
        <div class="col-md-10 mt-2 module-title text-sm-center text-md-left">
            <h2>{{ title }}</h2>
        </div>
    </div>
</div>